<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import HonorValidatorTab from "./components/HonorValidatorTab.vue";
import HonorPenyusunSoalTab from "./components/HonorPenyusunSoalTab.vue";

export default {
  page: {
    title: "Perhitungan Honor",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    HonorValidatorTab,
    HonorPenyusunSoalTab,
  },
  data() {
    return {
      title: "Perhitungan Honor",
      items: [],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="d-flex justify-content-end mb-3">
      <router-link :to="{ name: 'all-kompetensi-level' }" class="btn btn-light btn-sm">
        <i class="fa fa-arrow-left me-1"></i> Kembali ke Kompetensi Level
      </router-link>
    </div>

    <b-tabs class="honor-tabs" content-class="pt-3" nav-class="nav-tabs-custom">
      <b-tab title="Perhitungan Honor Validator" active>
        <HonorValidatorTab />
      </b-tab>
      <b-tab title="Perhitungan Honor Penyusun Soal">
        <HonorPenyusunSoalTab />
      </b-tab>
    </b-tabs>
  </Layout>
</template>

<style scoped>
.honor-tabs :deep(.nav-tabs-custom) {
  gap: 0.25rem;
  border-bottom-color: #e9ecef;
}

.honor-tabs :deep(.nav-link) {
  color: #6c757d;
  font-weight: 600;
  padding: 0.65rem 1rem;
}

.honor-tabs :deep(.nav-link.active) {
  color: #1f2937;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
</style>
